import { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import Logo from "./assets/images/company-logo-desk.svg";

// Create a CSS file for the animation
const loaderStyles = `
  @keyframes pulse {
    0% {
      opacity: 1;
      transform: scale(1);
    }
    50% {
      opacity: 0.7;
      transform: scale(1.05);
    }
    100% {
      opacity: 1;
      transform: scale(1);
    }
  }
  
  .loader-logo {
    animation: pulse 1.5s ease-in-out infinite;
  }
  
  .loader-container {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    z-index: 9999 !important;
    background-color: #f8f9fa !important;
  }
`;

// Inject styles into the document
const styleSheet = document.createElement("style");
styleSheet.textContent = loaderStyles;
document.head.appendChild(styleSheet);

// ----------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter basename="/">
    <Suspense
      fallback={
        <div className="loader-container">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
            }}
          >
            <img
              src={Logo}
              alt="PSN Finance"
              className="loader-logo"
              style={{
                height: "80px",
                width: "auto",
              }}
            />
          </div>
        </div>
      }
    >
      <App />
    </Suspense>
  </BrowserRouter>,
);
